// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__mFDrF","faqBox":"FAQ_faqBox__QSVKX","faqBox_acc":"FAQ_faqBox_acc__zHAVC","previewWrapper":"FAQ_previewWrapper__f1Jgu","faq_buttonBox":"FAQ_faq_buttonBox__O7UjN"};